import * as PIXI from "pixi.js";


export default class HandleButton extends PIXI.Container
{
    constructor(type, mode)
    {
        super();

        this.handleType = type;
        this.mode = mode;

        this.build();
        this.bindEvents();
    }

    build ()
    {
        this.gfx = new PIXI.Graphics();
        this.gfx.lineStyle({width: 2, color: 0x85caff});
        this.gfx.beginFill(0x85caff, 0.001);
        this.gfx.drawRoundedRect(-15,-15, 30, 30, 5);
        this.gfx.endFill();
        this.gfx.visible = this.handleType !== "rotate";


        this.gfxCircle = new PIXI.Graphics();
        this.gfxCircle.lineStyle({width: 2, color: 0x85caff});
        this.gfxCircle.beginFill(0x85caff, 0.001);
        this.gfxCircle.drawCircle(0,0, 15);
        this.gfxCircle.endFill();
        this.gfxCircle.visible = this.handleType === "rotate";

        this.addChild(this.gfx);
        this.addChild(this.gfxCircle);
    }

    bindEvents ()
    {
        this.interactive = true;

        this.fctDragStart = this.onDragStart.bind(this)
        this.fctDrag = this.onDrag.bind(this)
        this.fctDragEnd = this.onDragEnd.bind(this)

        this.on("pointerdown", this.fctDragStart)


    }

    changeMode (mode)
    {
        //if (this.handleType !== mode)
        {
            this.handleType = mode;


            // this.gfx.visible = mode !== "rotate";
            // this.gfxCircle.visible = mode === "rotate";

        }
    }
    onDragStart (event)
    {

        this.off("pointerdown", this.fctDragStart);

        this.interactive = false;
        //this.startDragPosition = {x:event.nativeEvent.clientX, y: event.nativeEvent.clientY};
        this.startDragPosition = {x:event.data.global.x, y: event.data.global.y};

        window.addEventListener("pointermove", this.fctDrag)
        window.addEventListener("pointerup", this.fctDragEnd)



        const parent = this.parent.parent;

        parent.interactive = false;





        const scale = parent.sprite.scale.x;
        const width = parent.sprite.width;
        const height = parent.sprite.height;
        const rotation = parent.sprite.rotation;
        const x = this.x;
        const y = this.y;

        let position = this.toGlobal({x, y});
        let center = this.toGlobal({x: parent.x, y: parent.y});


        const start = { scale, width, height, rotation, x, y, position, center }
        this.spriteStartInfo = start;


        //setTimeout(() => window.pixi.trackHandle(event, start), 1);


        // window.pixiStage.on("pointermove", this.fctDrag);
        // window.pixiStage.on("pointerup", this.fctDragEnd);
        // window.pixiStage.on("pointerupoutside", this.fctDragEnd);
    }

    onDrag (event)
    {

        //this.emit("move-handle", { position, handle: this, start: this.spriteStartInfo })
        this.emit("move-handle", { event, handle: this })
    }

    onDragEnd (event)
    {
        console.log("Handle::onDragEnd")
        // window.pixiStage.off("pointermove", this.fctDrag);
        // window.pixiStage.off("pointerup", this.fctDragEnd);
        // window.pixiStage.off("pointerupoutside", this.fctDragEnd);

        window.removeEventListener("pointermove", this.fctDrag)
        window.removeEventListener("pointerup", this.fctDragEnd)
        this.on("pointerdown", this.fctDragStart);
        this.interactive = true;
        this.parent.interactive = true;
    }

}
